
import React, { HTMLAttributes } from 'react';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ButtonWrapper, Text } from '../../../components';
import splitReadMore from '../../../helpers/splitReadMore';
import { ParagraphText as Type } from '../../../types/uncinc_profile/paragraphs';
import type { HeadingTag } from '../../../types';

import './style.scss';

interface ParagraphTextProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
  noBootstrap?: boolean;
  headingTag?: HeadingTag;
  textColClass?: string;
}

const ParagraphText: React.FC<ParagraphTextProps> = ({
  entity,
  noBootstrap,
  headingTag,
  textColClass,
}) => {
  const paragraphText = entity.toJS();
  const paragraphColClasses = noBootstrap ? 'col-12' : (textColClass || 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2');
  const title = paragraphText.field_title[0]?.value;
  const bodyRaw = paragraphText.field_body[0]?.processed || '';
  const { intro, readMore } = splitReadMore(bodyRaw);
  const link = paragraphText.field_link[0];
  const linkTitle = link?.title;
  const linkUrl = link?.alias || link?.uri;
  const linkTarget = link?.options?.attributes?.target;
  const secondaryLink = paragraphText.field_link_secondary[0];
  const secondaryLinkTitle = secondaryLink?.title;
  const secondaryLinkUrl = secondaryLink?.alias || secondaryLink?.uri;
  const secondaryLinkTarget = secondaryLink?.options?.attributes?.target;

  return (
    <div className="Paragraph ParagraphText">
      <Container>
        <div className="row">
          <div className={paragraphColClasses}>
            <Text
              title={title}
              text={intro}
              readMore={readMore}
              readMoreHeight={60}
              className="text--regular"
              headingTag={headingTag}
            >
              {(linkUrl || secondaryLinkUrl) && (
                <div className="ParagraphText__buttons">
                  {linkUrl && (
                    <ButtonWrapper
                      href={linkUrl}
                      target={linkTarget}
                    >
                      {linkTitle}
                    </ButtonWrapper>
                  )}
                  {secondaryLinkUrl && (
                    <ButtonWrapper
                      href={secondaryLinkUrl}
                      target={secondaryLinkTarget}
                    >
                      {secondaryLinkTitle}
                    </ButtonWrapper>
                  )}
                </div>
              )}
            </Text>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphText;
